import React, { useEffect, useState } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";

// import FullDataTable from "../../../../Components/ExtraComponents/Datatable/FullDataTable"
import { GET_HELPS } from "../../../../ReduxStore/Slice/Admin/AdminHelpSlice";
import { useDispatch } from "react-redux";
import { fDateTime } from "../../../../Utils/Date_formet";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";

const HelpCenter = () => {
  const dispatch = useDispatch();

  const user_id = JSON.parse(localStorage.getItem("user_details")).user_id;
  const token = JSON.parse(localStorage.getItem("user_details")).token;

  const [getAllClients, setAllClients] = useState({
    loading: true,
    data: [],
  });

  const data = async () => {
    await dispatch(GET_HELPS({ user_id: user_id, token: token }))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllClients({
            loading: false,
            data: response.data,
          });
        } else {
          setAllClients({
            loading: false,
            data: response.data,
          });
        }
      });
  };
  useEffect(() => {
    data();
  }, []);

  const columns = [
    {
      name: "User Name",
      selector: (row) => row.username,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Phone Number",
      selector: (row) => row.mobile,
      sortable: true,
    },
    {
      name: "Help Message",
      selector: (row) => row.help_msg?.replace(/<[^>]*>/g, ""),
      sortable: false,
      wrap: true,
    },
    {
      name: "Date",
      selector: (row) => row.createdAt,
      cell: (row) => <>{row.createdAt ? fDateTime(row.createdAt) : "-"}</>,
      sortable: true,
    },
  ];

  return (
    <Content Page_title="Help Center" button_status={false}>
      <Table columns={columns} data={getAllClients?.data || []} />
    </Content>
  );
};

export default HelpCenter;
